'use client';

import { useTelegramBackButtonSetup } from '@/hooks/useTelegramBackButton';

export function TelegramBackButtonSetup() {
  useTelegramBackButtonSetup();
  return null;
}
